import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../Redux/common/actions";
import { Box, Dialog, DialogContent, Grid, IconButton } from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { auditLog } from "../../utils/auditLog";
import useFetchCandidateTokenDetails from "../../hooks/useFetchCandidateTokenDetails";

export default function InstructionModal({ filteredInstructions, value }) {
  // Derieved variables
  const dispatch = useDispatch();
  const { showModal } = useSelector((state) => state.commonReducer);
  const { heartBeat } = useSelector((state) => state.examReducer);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  useFetchCandidateTokenDetails({ setCandidateTokenDetails });
  // Helper functions
  const handleClose = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "I", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User closed Instruction Popup In Live Test",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  return (
    <>
      <Dialog
        open={showModal?.show && showModal?.method === "I"}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "8px",
            backgroundColor: "rgba(240, 240, 251, 1)",
          },
        }}
      >
        <DialogContent
          sx={{
            width: "100%",
            backgroundColor: "rgba(240, 240, 251, 1)",
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(63, 65, 209, 1)",
            },
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 4,
              color: "#000",
            }}
          >
            <IoMdCloseCircleOutline />
          </IconButton>
          <Grid
            p={2}
            sx={{
              minHeight: "350px",
              width: "100%",
            }}
          >
            <Grid component={"p"} sx={{}} />
            {filteredInstructions?.map((instruction, index) => (
              <Box value={value} index={index} key={index}>
                <Grid
                  p={3}
                  sx={{ fontSize: 18 }}
                  dangerouslySetInnerHTML={{
                    __html: instruction?.value,
                  }}
                />
              </Box>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
